
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/properties/[search_term]",
      function () {
        return require("private-next-pages/properties/[search_term]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/properties/[search_term]"])
      });
    }
  